import { authRoles } from 'app/auth';
import CaptchaTypeEditForm from './editform/CaptchaTypeEditForm';
import CaptchaTypeTable from './table/CaptchaTypeTable';

export default [
	{
		path: '/captchatype/edit/:id',
		component: CaptchaTypeEditForm,
		auth: authRoles.userAccount
	},
	{
		path: '/captchatype/:sessionNameParam?',
		component: CaptchaTypeTable,
		auth: authRoles.userAccount
	}
];
